import { ARGBColor } from '../../../../../../api/com/MetaPattern/MDA/Designer/Base/ARGBColor';

export class ARGBColorHelper {
  static toRGBString(color: ARGBColor): string {
    return `#${color.red.toString(16)}${color.green.toString(16)}${color.blue.toString(16)}`;
  }
}
